import 'slick-carousel';

// Hero Slider
$('.hero-slider').slick({
    dots: true,
    fade: true,
    arrows: true,
    infinite: true,
    autoplay: true,
    lazyLoad: 'ondemand',
    autoplaySpeed: 4000
});

// Livetrade Landing : Two Col Sider Component
$('.two-col-slider').slick({
    dots: true,
    arrows: true,
    infinite: true,
    rows: 0, // Fix for v1.8.0-1
    slidesToShow: 1,
    mobileFirst: true,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2,
            }
        },
    ]
});

// Livetrade Landing : Explore Wines Component
$('.explore-wines-slider').slick({
    dots: true,
    infinite: true,
    rows: 2, // Fix for v1.8.0-1
    slidesToShow: 1,
    mobileFirst: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                rows: 0,
                slidesToShow: 4,
            }
        },
    ]
});

// Livetrade Landing : Blockquote Component
$('.blockquote-slider').slick({
    centerPadding: false,
    dots: true,
    infinite: true,
    fade: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    rows: 0 // Fix for v1.8.0-1
});

$(function () {
    $('.top-icons').slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        slidesPerRow: 1,
        dots: true,
        arrows:false,
        autoplay: true,
        rows: 0,
        infinite: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 3,
                    slidesPerRow: 3
                }
            }
        ]
    });
});


// Livetrade Landing : Knowledge Component
$('.knowledge-slider').slick({
    dots: true,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    mobileFirst: true,
    arrows: false,
    rows: 0, // Fix for v1.8.0-1
    responsive: [
        {
            breakpoint: 1280,
            settings: {
                centerMode: false,
                slidesToShow: 4
            }
        },
        {
            breakpoint: 768,
            settings: {
                centerMode: true,
                slidesToShow: 3
            }
        },
        {
            breakpoint: 500,
            settings: {
                centerMode: true,
                slidesToShow: 2
            }
        },
    ]
});

// Article Grid Sliders : Learn Area
$('.grid-slider').slick({
    dots: true,
    arrows: true,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    slidesPerRow: 1,
    rows: 0, // Fix for v1.8.0-1
    mobileFirst: true,
    responsive: [
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 2,
                slidesPerRow: 2,
                dots: false
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesPerRow: 4,
                dots: false,
            }
        },
    ]
});

// Livetrade Landing : Region Slider
$('.region-slider').slick({
    dots: true,
    arrows: false,
    infinite: true,
    rows: 0, // Fix for v1.8.0-1
    slidesToShow: 1,
    mobileFirst: true,
    responsive: [
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 1024,
            settings: {
                rows: 0,
                slidesToShow: 5,
            }
        },
    ]
});

// Livetrade Landing : Four Col Image Slider
$('.four-col-image-slider').slick({
    dots: true,
    arrows: false,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    slidesPerRow: 1,
    rows: 0, // Fix for v1.8.0-1
    mobileFirst: true,
    responsive: [
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 2,
                slidesPerRow: 2,
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesPerRow: 4
            }
        },
    ]
});

// Reloading Slick Sliders that are within Livetrade Landing Tab Panels
// Otherwise they will not load correctly
$('a[data-bs-toggle="list"]').on('shown.bs.tab', function (e) {
    $('.slick-slider').slick('refresh');
});

// Featured Producer Slider
$('.featured-producer-slider').slick({
    dots: true,
    rows: 0, // Fix for v1.8.0-1
    slidesToShow: 1,
    mobileFirst: true
});

// Producer Landing : Five Col Image Slider
$('.producer-five-col-image-slider').slick({
    dots: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    slidesPerRow: 2,
    rows: 0, // Fix for v1.8.0-1
    mobileFirst: true,
    responsive: [
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 3,
                slidesPerRow: 3,
            }
        },
        {
            breakpoint: 900,
            settings: {
                slidesToShow: 4,
                slidesPerRow: 4
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 5,
                slidesPerRow: 5
            }
        },
    ]
});

// Producer Landing : Four Col Image Sliders (Burgundy/Italy)
$('.producer-four-col-image-slider').slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    slidesPerRow: 1,
    rows: 0, // Fix for v1.8.0-1
    mobileFirst: true,
    responsive: [
        {
            breakpoint: 400,
            settings: {
                slidesToShow: 2,
                slidesPerRow: 2,
            }
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 3,
                slidesPerRow: 3,
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesPerRow: 4
            }
        },
    ]
});

// Producer Landing : Three Col Image Slider
$('.producer-three-col-image-slider').slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    slidesPerRow: 1,
    rows: 0, // Fix for v1.8.0-1
    mobileFirst: true,
    responsive: [
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 2,
                slidesPerRow: 2,
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesPerRow: 3
            }
        },
    ]
});